import MoneyIcon from "@mui/icons-material/Money";
import { AddIcon } from "./ActionIcons";
import SegmentIcon from "@mui/icons-material/Segment";

export function TarjousIcon(props) {
  return <MoneyIcon color="primary" {...props} />;
}
export function NewTarjousIcon(props) {
  return (
    <div style={{ position: "relative", width: 40, height: 30 }}>
      <AddIcon
        {...props}
        style={{ position: "absolute", left: -13, top: 5, fontSize: "20px", opacity: 0.7 }}
      />
      <TarjousIcon color="primary" {...props} style={{ position: "absolute", left: 0, top: 5 }} />
    </div>
  );
}

export function TarjousRiviIcon(props) {
  return <SegmentIcon {...props} />;
}
